export const agritechQuestions = {
  tier1: [
    {
      question: "What does a biofertilizer provide to plants?",
      answers: [
        "Nutrients and natural compounds that support their growth.",
        "Hormones that protect them from leafcutter ants.",
        "Enzymes that function as natural nitrogen.",
        "SPF 60 that protects them from ultraviolet radiation.",
      ],
      correctIndex: 0,
    },
    {
      question: "What is urban agriculture?",
      answers: [
        "Growing food within or near cities.",
        "Growing food on farms and transporting it to cities.",
        "Cultivating a sour culture in cities.",
        "Agriculture can only be rural.",
      ],
      correctIndex: 0,
    },
    {
      question: "What does more sustainable agriculture seek to do?",
      answers: [
        "Reduce environmental impact by using alternatives such as biofertilizers.",
        "Reduce environmental impact by encouraging the importation of products and tools from abroad.",
        "Hide the environmental impact of excessive synthetic fertilizer use.",
        "Buy at the lowest price and sell at the highest price.",
      ],
      correctIndex: 0,
    },
    {
      question: "What advantage can a biofertilizer offer?",
      answers: [
        "Reducing dependence on synthetic inputs.",
        "Protecting crops against every pest.",
        "They are functionally the same as chemical fertilizers, but cheaper.",
        "Installing artificial intelligence in plants.",
      ],
      correctIndex: 0,
    },
    {
      question: "Why can microalgae be useful for making biofertilizers?",
      answers: [
        "Because they produce biomass rich in nutrients and bioactive compounds.",
        "Because they perform photosynthesis and produce oxygen.",
        "Because they live mainly in aquatic environments.",
        "Because they are primary producers in many aquatic ecosystems.",
      ],
      correctIndex: 0,
    },
  ],

  tier2: [
    {
      question: "What is a bioactive compound?",
      answers: [
        "A natural substance that can influence processes in a plant.",
        "Nitrogen is an essential nutrient for plants.",
        "Proteins are part of microalgal biomass.",
        "Biofertilizers can contain different natural compounds.",
      ],
      correctIndex: 0,
    },
    {
      question: "What can result from the excessive use of synthetic inputs?",
      answers: [
        "Pollution and ecosystem degradation.",
        "They cannot be overused because the crop absorbs everything and none of it reaches groundwater.",
        "Only an unnecessary expense for the farmer.",
        "Leaching into groundwater, but without environmental consequences.",
      ],
      correctIndex: 0,
    },
    {
      question: "Why is fertilizer runoff a concern?",
      answers: [
        "Because it can contaminate nearby water sources and affect surrounding ecosystems.",
        "Because neighbors can use the runoff to grow their crops.",
        "Because the farmer loses money on nutrients that the crops did not absorb.",
        "Because nitrogen is difficult to obtain.",
      ],
      correctIndex: 0,
    },
    {
      question: "What makes agriculture NOT sustainable?",
      answers: [
        "Using resources in a way that compromises their availability for future generations.",
        "Meeting current needs without depleting natural resources.",
        "Growing food locally to reduce transportation distances and their environmental impact.",
        "Reducing environmental impacts through alternatives such as biofertilizers.",
      ],
      correctIndex: 0,
    },
    {
      question:
        "What challenge does nutrient management present in urban agriculture?",
      answers: [
        "Providing what is needed without wasting resources or causing pollution.",
        "Only agricultural experts can manage nutrients correctly.",
        "Biofertilizers require large quantities of natural resources to produce.",
        "There is no room for agriculture in cities.",
      ],
      correctIndex: 0,
    },
  ],

  tier3: [
    {
      question:
        "Why is it important to reduce the environmental consequences of fertilizers?",
      answers: [
        "Because the degradation of water, soil, and ecosystems also threatens long-term agricultural production.",
        "Because environmental impacts only matter when they immediately reduce the harvest.",
        "Because a productive crop compensates for any damage caused outside the agricultural land.",
        "Because affected ecosystems always recover when fertilizer use is stopped.",
      ],
      correctIndex: 0,
    },
    {
      question: "Why does this biofertilizer work without living microalgae?",
      answers: [
        "Because the biomass retains nutrients and useful compounds.",
        "Because the cells begin growing again after the product is applied.",
        "Because microalgae are sustainable, so they revive after drying.",
        "Because microalgae are not biological organisms.",
      ],
      correctIndex: 0,
    },
    {
      question: "How can a biofertilizer support plant nutrition?",
      answers: [
        "By providing nutrients and supporting their absorption.",
        "By providing the plant with nutrients and photosynthesis.",
        "By providing all the water the crop needs.",
        "By providing microalgae that release the same nutrients as a Triple 15 fertilizer.",
      ],
      correctIndex: 0,
    },
    {
      question: "Why should the quality of a biofertilizer be evaluated?",
      answers: [
        "To verify that it is safe, stable, and suitable for use.",
        "Because every biological product contains dangerous microorganisms.",
        "Because a natural product does not need to have its effectiveness verified.",
        "Because its quality depends solely on how much nitrogen it contains.",
      ],
      correctIndex: 0,
    },
    {
      question: "Why is it important to develop bioinputs in Medellín?",
      answers: [
        "It enables the creation of solutions adapted to local needs and with a reduced environmental impact.",
        "It guarantees that no external input will ever be needed.",
        "It makes testing locally developed technologies unnecessary.",
        "It means that all agriculture could be transferred to the city.",
      ],
      correctIndex: 0,
    },
  ],
};
